import { DialogContent, Typography, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DeviceDenied from './DeviceDenied';
import NoDevice from './NoDevice';
import ErrorTitle from './ErrorTitle';

const CameraTakenError = () => {
  const { t } = useTranslation();
  return (
    <>
      <ErrorTitle title={t("We can't access your camera")} />
      <DialogContent>
        <Grid item>
          <Typography fontSize="14px">
            {t(
              'The camera seems to be used by a different application (like Teams, Zoom or another browser). Please close such applications and press "Retry"'
            )}
          </Typography>
        </Grid>
      </DialogContent>
    </>
  );
};

const VideoPermissionDeniedError = () => {
  const { t } = useTranslation();
  return (
    <>
      <ErrorTitle title={t("We can't access your camera")} />
      <DeviceDenied device="camera" reason="denied" />
    </>
  );
};

const VideoPermissionBlockedError = () => {
  const { t } = useTranslation();
  return (
    <>
      <ErrorTitle title={t("We can't access your camera")} />
      <DeviceDenied device="camera" reason="blocked" />
    </>
  );
};

const NoCameraError = () => {
  const { t } = useTranslation();
  return (
    <>
      <ErrorTitle
        title={t('We could not detect any {{device}}', { device: t('camera') })}
      />
      <NoDevice device="camera" />
    </>
  );
};

export {
  CameraTakenError,
  VideoPermissionDeniedError,
  VideoPermissionBlockedError,
  NoCameraError,
};
